import { gql } from '@apollo/client';

export const UPDATE_GLOBAL_SETTING = gql`
  mutation UpdateChatbotGlobalSetting($params: UpdateGlobalSettingInput!) {
    updateChatbotGlobalSetting(params: $params) {
      success
      message
      errors
      data {
        id
        settingKey
        settingValue
        settingType
        description
        createdAt
        createdBy
      }
    }
  }
`;
